import * as z from 'zod';

export const APP_NAME = 'BookWrightOnline';

export const TypeSchema = z.strictObject({
  type: z.string(),
  source: z.string().nullable(),
  userID: z.string().nullable(),
  username: z.string().nullable(),
  title: z.string().nullable(),
  projectStartDateUTC: z.string().nullable(),
});

export const AppStartEventData = TypeSchema.extend({
  userAgent: z.string(),
});

export const LoginEventData = TypeSchema.extend({
  login: z.string(),
});

export const LoginFailEventData = TypeSchema.extend({
  loginFail: z.strictObject({
    reason: z.string(),
    username: z.string(),
  }),
});

export const RegisterEventData = TypeSchema.extend({
  login: z.string(),
});

export const RegisterFailEventData = TypeSchema.extend({
  registerFail: z.strictObject({
    reason: z.string(),
    username: z.string(),
  }),
});

export const NewProjectEventData = TypeSchema.extend({
  blurbID: z.string(),
});

export const ImageUploadFailedEventData = TypeSchema.extend({
  imageID: z.string().optional(),
  thumbPath: z.string().optional(),
  imageDetails: z.string(),
  error: z.string().optional(),
});

export const AddToCartEventData = TypeSchema.extend({
  source: z.string().nullable(),
});

export const RenderFailedEventData = TypeSchema.extend({
  error: z.string(),
  status: z.string(),
  renderJobPK: z.string(),
});

export const UploadFailedEventData = TypeSchema.extend({
  error: z.string(),
  status: z.string(),
  renderJobPK: z.number(),
});

export const EventSchema = z.strictObject({
  data: z.union([
    AppStartEventData,
    LoginEventData,
    LoginFailEventData,
    RegisterEventData,
    RegisterFailEventData,
    NewProjectEventData,
    ImageUploadFailedEventData,
    AddToCartEventData,
    RenderFailedEventData,
    UploadFailedEventData,
  ]),
  timestamp: z.string(),
});

export const DataSchema = z.strictObject({
  branch: z.literal('production'),
  build: z.literal('0'),
  commit: z.string(),
  context: z.literal(APP_NAME),
  events: EventSchema.array(),
  instance_id: z.string(),
  project_id: z.string().regex(/^\d+/).nullable(),
  version: z.string(),
});
